import { render, staticRenderFns } from "./ChartStatsTable.vue?vue&type=template&id=822e6138&"
import script from "./ChartStatsTable.vue?vue&type=script&lang=js&"
export * from "./ChartStatsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports